import { animate, AnimationBuilder, AnimationFactory, AnimationPlayer, style } from '@angular/animations';
import { Component, ContentChildren, ElementRef, HostListener, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { catchError, of } from 'rxjs';
import { CarouselItemElementDirective } from './carousel/carousel-item-element.directive';
import { CarouselItemDirective } from './carousel/carousel-item.directive';
import { FeedService } from './feed.service';

export interface FeedItem {
    title: string;
    link: string;
    publishDate: Date;
    category: string;
    description: string;
    image?: string;
    imageLink?: string;
    imageAlt?: string;
    imageTitle?: string;
}

@Component({
    selector: 'app-feed',
    templateUrl: './feed.component_new.html',
    styleUrls: ['./feed.component.scss'],
})
export class FeedComponent implements OnInit {
    feedData: FeedItem[] = [];
    items: FeedItem[] = [];
    postCarousol: FeedItem[] = [];
    loading = true;
    setslides = 0;
    start;

    // @Input() schoolFeed = 'https://slhe.polkschoolsfl.com/feed/';

    constructor(private feedService: FeedService) { }

    ngOnInit(): void {
        const self = this;
        const schoolFeed = 'https://slhe.polkschoolsfl.com/feed/';

        self.feedService.getFeeds(schoolFeed).subscribe(data => {
            if (data) {
                self.feedData = data;

                for (let i = 0; i <= 3; i++) {
                    self.postCarousol.push(self.feedData[i]);
                };
                self.items = self.postCarousol;
                self.loading = false;
            }
        });


        // setSlides(window.innerWidth);
        self.start = 0;
    }


    trackByIndex(index, post) {
        return post;
    }
}


// function setSlides(value) {
//     if (value < 700) { this.setslides = 1; }
//     else if (value >= 700 && value < 1000) { this.setslides = 2; }
//     else if (value >= 1000 && value < 1200) { this.setslides = 3; }
//     else { this.setslides = 4; }
// };
